<template>
  <div>
    <slot></slot>
    <p class="rows-selected">
       {{ $t('Выбрано записей') }}:
      <b>{{ totalCount }}</b>
    </p>
    <div class="card">
      <dx-grid :key="gridKey" :getRowId="getRowId" :rows="dataSource" :columns="columns">
        <dx-paging-state :currentPage="currentPage" :pageSize="pageSize" @update:pageSize="onPageSizeUpdate"  @update:currentPage="onPageChange"/>
        <dx-sorting-state
          :sorting.sync="sorting"
          @update:sorting="changeSorting"
        />
        <dx-selection-state
          :selection.sync="selection"
          @update:selection="$emit('selectionChange', $event)"
        />
        <dx-custom-paging :totalCount="totalCount" />
        <dx-table
          :tableComponent="$options.components.TableStriped"
          :rowComponent="$options.components.Row"
          :cellComponent="$options.components.Cell"
          :columnExtensions="tableColumnExtensions"
          :messages="{
            noData: emptyDataLabel
              ? emptyDataLabel
              : $t('Отсутствуют подходящие данные'),
          }"
        />
        <dx-table-header-row
          :rowComponent="$options.components.HeaderRow"
          :showSortingControls="enableSorting"
        />
        <dx-integrated-selection />
        <dx-table-selection
          v-if="isCheckable"
          showSelectAll
        />
        <dx-paging-panel :messages="{ showAll: $t('Все') }" :pageSizes="enableChangePageSize && rows && rows.length ? [10, 15, 25, 50, 0] : []" v-if="enableSorting || enablePaging" />
      </dx-grid>
    </div>
  </div>
</template>

<script>
import printJS from 'print-js';
import '@devexpress/dx-vue-grid-bootstrap4/dist/dx-vue-grid-bootstrap4.css';
import 'open-iconic/font/css/open-iconic-bootstrap.css';
import GridMixin from './Grid.mixin';
import axios from 'axios';
import { EventBus } from '@/event-bus';
import LrModal from '@/pages/donors/SendToLrModal';
import {
  DxSelectionState,
  DxPagingState,
  DxSortingState,
  DxIntegratedPaging,
  DxIntegratedSelection,
  DxCustomPaging,
} from '@devexpress/dx-vue-grid';
import {
  DxGrid,
  DxTable,
  DxTableSelection,
  DxTableHeaderRow,
  DxPagingPanel,
} from '@devexpress/dx-vue-grid-bootstrap4';

import Cell from './cells/Cell';
import Row from './Row';
import HeaderRow from './HeaderRow';
import TableStriped from './TableStriped';
import { faMarker } from '@fortawesome/free-solid-svg-icons';

export default {
  name: 'rdkm-gridview',
  mixins: [GridMixin],
  props: {
    state: Object,
    rows: Array,
    export: {
      type: Boolean,
      default: false,
    },
    enableSorting: {
      type: Boolean,
      default: true,
    },
    enablePaging: {
      type: Boolean,
      default: false
    },
    enableChangePageSize: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number | null,
      default: null
    },
    exportUrl: {
      type: String,
      default: '',
    },
    defaultSortColumn: {
      type: String,
      default: '1',
    },
    isCheckable: {
      type: Boolean,
      default: false,
    },
    emptyDataLabel: {
      type: String,
      default: '',
    },
    urlPrefix: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      delay: 1000,
      clicks: 0,
      gridKey: 1,
      timer: null,
      showExport: this.export || false,
      dataSource: [],
      selection: [],
      lastSelection: 0,
      columns: [],
      sorting: [
        {
          columnName: this.state.column || this.defaultSortColumn || '1',
          direction: this.state.orderby || 'desc',
        },
      ],
      totalCount: this.total || (this.rows ? this.rows.length : 0),
      pageSize: parseInt(this.state.take || 100),
      currentPage: 0,
      query: { take: this.state.take || 100 },
      columnComponents: [],
    };
  },
  computed: {
    tableColumnExtensions: function() {
      const arr = [
        { columnName: 'COPY', width: 40, align: 'right' },
        { columnName: 'EDIT', width: 40, align: 'left' },
        { columnName: 'DELETE', width: 40, align: 'right' },
      ];

      const columnsWidth = this.columnComponents
        .filter(function(item, index) {
          return item.width && item.title;
        })
        .map((column) => ({
          columnName: column.name,
          width: parseInt(column.width),
          wordWrapEnabled: true,
        }));
      return arr.concat(columnsWidth);
    },
  },
  mounted() {
    this.columnComponents = this.$slots.default
      .filter((column) => column.componentInstance)
      .map((column) => column.componentInstance);
    this.columns = this.columnComponents.map((column) => ({
      name: column.name,
      title: column.title || ' ',
      cell: column.$attrs['cell'],
      url: column.$attrs['url'],
      urlPrefix: column.$attrs['urlPrefix'],
      tooltipTitle: column.$attrs['tooltipTitle'],
      format: column.$attrs['format'],
      action: column.$attrs['action'],
      className: column.$attrs['className'],
      isDeleteWithConfirm:  column.$attrs['isDeleteWithConfirm']
    }));
    EventBus.$on('grid-title-changed', (title) => {
      for(let i = 0; i < this.columns.length; i++) {
        if(this.columns[i].name == title.name) {
          this.columns[i].title = title.val;
        }
      }
    });
    this.currentPage = (this.state.skip || 0) / this.pageSize;
    this.filter(this.state);
  },
  updated() {
    this.filter();
  },
  methods: {
    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.$emit('currentPageChange', this.currentPage);
    },
    onPageSizeUpdate(pageSize) {
      this.pageSize = pageSize;
      this.$emit('pageSizeChange', this.pageSize);
    },
    print() {
      printJS({
        printable: this.exportUrl,
        type: 'pdf',
        modalMessage: this.$t('Загрузка документа...'),
        showModal: true,
      });
    },
    filter(form, resetPager) {
      if (this.rows) {
        this.dataSource = this.rows;
        this.totalCount = this.total || this.rows.length;
        return;
      }

      if (resetPager) {
        this.currentPage = 0;
      }
      this.query['take'] = this.pageSize;
      this.query['skip'] = this.pageSize * this.currentPage;
      this.query['orderby'] = this.sortDirection();

      if (form) {
        for (let k in form) {
          if (form.hasOwnProperty(k)) {
            this.query[k] = form[k];
          }
        }
      }

      this.query['column'] = this.sortColumn();
      if (this.clicks === 0)
        this.$router.replace({ path: this.$router.path, query: this.query });
      this.loadRows();
    },
    changeSorting(sorting) {
      this.sorting = sorting;
    },

    sortColumn() {
      return this.sorting[0].columnName;
    },

    sortDirection() {
      return this.sorting[0].direction;
    },

    refreshGrid(queryString) {
      if (!queryString) {
        queryString = this.$route.fullPath;
      }
      if (this.selection && this.selection.length > 0) {
        this.selection = [];
      }
      if(this.urlPrefix) {
        queryString = '/' + this.urlPrefix + queryString;
      }
      this.lastQuery = this.$route.fullPath;
      EventBus.$emit('showThrobber');

      axios
        .get(queryString, {
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
          },
        })
        .then((response) => {
          let totalCount = response.data.totalCount || response.data.total_count;
          this.dataSource = response.data.rows;
          this.totalCount = totalCount;
          EventBus.$emit('hideThrobber');
          EventBus.$emit('gridDataLoaded', response.data);
        })
        .catch(() => {
          EventBus.$emit('hideThrobber');
        });
    },
    loadRows() {
      const queryString = this.$route.fullPath;
      if (queryString === this.lastQuery) {
        return;
      }

      this.refreshGrid(this.$route.fullPath);
    }
  },
  components: {
    DxSelectionState,
    DxPagingState,
    DxSortingState,
    DxIntegratedSelection,
    DxIntegratedPaging,
    DxCustomPaging,
    DxGrid,
    DxTable,
    DxTableHeaderRow,
    DxPagingPanel,
    Cell,
    DxTableSelection,
    Row,
    HeaderRow,
    TableStriped,
    LrModal,
  },
};
</script>

<style>
.text-primary {
  color: #0b8177 !important;
}

.text-center [classname='text-muted'] {
  font-size: 14px;
}

.pagination .disabled:nth-last-child(-n + 3) {
  display: none;
}
</style>
